import styled from 'styled-components';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import Link from '../../../../atoms/Link';
export var ItemIcon = styled(ListItemIcon).withConfig({
  displayName: "style__ItemIcon",
  componentId: "sc-orhu7r-0"
})(["&&{min-width:initial;color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme && theme.grey[500];
});
export var ItemText = styled(ListItemText).withConfig({
  displayName: "style__ItemText",
  componentId: "sc-orhu7r-1"
})(["transition:background-color 225ms cubic-bezier(0.4,0,0.6,1) 0ms;padding-left:1rem;overflow-x:hidden;white-space:nowrap;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme && theme.grey[600];
});
export var Item = styled(ListItem).withConfig({
  displayName: "style__Item",
  componentId: "sc-orhu7r-2"
})(["&&{overflow-x:hidden;padding-top:16px;padding-bottom:16px;}.active &&{background-color:rgba(243,82,82,0.08);border-left:3px solid;padding-left:13px;color:", ";.MuiListItemIcon-root{color:", ";}.MuiListItemText-primary{color:", ";}}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.primary.main;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.primary.main;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.primary.main;
});
export var StyledLink = styled(Link).withConfig({
  displayName: "style__StyledLink",
  componentId: "sc-orhu7r-3"
})(["&&{text-decoration:none;&:hover{&&{text-decoration:none;}}}"]);